import { render, staticRenderFns } from "./guestFeatureRequest.vue?vue&type=template&id=05f80be8&scoped=true&"
import script from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
export * from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
import style0 from "./guestFeatureRequest.vue?vue&type=style&index=0&id=05f80be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f80be8",
  null
  
)

export default component.exports